var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 35h28.333a2.5 2.5 0 0 0 2.5-2.5V14.167a2.5 2.5 0 0 0-2.5-2.5h-17.5l-4.267-4.268a2.5 2.5 0 0 0-1.768-.732H8a2.5 2.5 0 0 0-2.5 2.5V32.5A2.5 2.5 0 0 0 8 35Z",
    fill: "#D1822C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.666 31.667h28.333a2.5 2.5 0 0 0 2.5-2.5V10.833a2.5 2.5 0 0 0-2.5-2.5H15.5l-4.267-4.268a2.5 2.5 0 0 0-1.768-.732H4.666a2.5 2.5 0 0 0-2.5 2.5v23.334a2.5 2.5 0 0 0 2.5 2.5Z",
    fill: "#F3B357"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.561 22.51h-3.26v3.346c0 .46-.374.833-.834.833H18.76a.833.833 0 0 1-.833-.833v-3.347h-3.26a.833.833 0 0 1-.637-1.371l4.947-5.843a.833.833 0 0 1 1.272 0l4.947 5.843a.833.833 0 0 1-.636 1.371Z",
    fill: "#EB9B2C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.670bc54111def89c443e81e3b45ef8c1.svg";
export { ForwardRef as ReactComponent };